import React from "react";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BlogIntroduction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="blog-introduction" className="bg-secondary/30 py-24 md:py-32 flex items-center justify-center">
      <div className="container mx-auto px-4">
        <div ref={ref} className={cn("mx-auto max-w-3xl border border-accent bg-background/60 p-10 text-center shadow-sm backdrop-blur-sm transition-all duration-1000 md:p-16", isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
          <h1 className="mb-6 font-serif text-4xl font-bold text-foreground md:text-5xl lg:text-6xl">
            Strategic Insights
          </h1>
          <div className="mx-auto h-px w-16 bg-accent mb-6" />
          <p className="font-sans text-lg leading-relaxed text-muted-foreground md:text-xl">
            A resource hub where Maia shares insights, case studies, and
            actionable strategies for entrepreneurs and growth‑stage companies.
            Discover the systems and leadership principles needed to scale with
            clarity and confidence.
          </p>
        </div>
      </div>
    </section>;
}